import { Section as SectionType } from "@folio-2026/experience"
import { PropsWithChildren, useMemo } from "react"

type Props = {
  name: SectionType
  height?: "full" | "random"
  className?: string
}

export default function Section({
  children,
  name,
  height,
}: PropsWithChildren<Props>) {
  const finalHeight = useMemo(() => {
    if (height === "full") {
      return 100
    } else if (height === "random") {
      return Math.floor(Math.random() * (300 - 100 + 1)) + 100
    }
  }, [height])

  return (
    <div
      data-name={name}
      style={{
        height: height ? `${finalHeight}vh` : undefined,
      }}
    >
      {children}
    </div>
  )
}
